export default __webpack_public_path__ + "static/media/330_business05-jp-web.66d4c710.png";